import { CELLTYPE_ENUM, SORTTYPE_ENUM } from 'common/components/table/table.constant';
import { ruppeeFormatter } from 'dedicated/components/plan-and-configuration/table/custom-table.constant';
import { prepareOptionsForDropDown } from 'dedicated/services/summary.service';
import { BANDWIDTH_LIST } from 'home/common/constants/constants';
import { IDropDown } from './rateCard.interface';

const serviceName: { [key: string]: string } = { MANAGED: 'Fully Managed', PARTIALLY_MANAGED: 'Partially Managed', UNMANAGED: 'Unmanaged' };
const serviceNameFormatter = (key: string): string => {
  return serviceName[key] ? serviceName[key] : '-';
};

const bandwidthFormatter = (value: string) => {
  return `${value} Mbps`;
};
const isMobile = () => {
  var mobileCheck = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
      return mobileCheck.Android() || mobileCheck.BlackBerry() || mobileCheck.iOS() || mobileCheck.Opera() || mobileCheck.Windows();
    }
  };
  return mobileCheck.any() ? true : false;
};

export const paginationLength = isMobile() ? 4 : 10;

export const TABLE_HEADERS = [
  {
    headerName: 'Bandwidth (in Mbps)',
    isSort: true,
    key: 'bandwidth',
    cellType: CELLTYPE_ENUM.LINK,
    sortKey: 'BANDWIDTH',
    sortType: SORTTYPE_ENUM.ASCENDING,
    formatter: bandwidthFormatter
  },
  {
    headerName: 'Service Type',
    isSort: true,
    sortType: SORTTYPE_ENUM.ASCENDING,
    sortKey: 'SERVICE_TYPE',
    key: 'serviceType',
    formatter: serviceNameFormatter
  },
  // {
  //   headerName: 'Media Type',
  //   isSort: false,
  //   sortType: null,
  //   key: 'mediaType'
  // },
  {
    headerName: 'One-time Charge*',
    isSort: true,
    sortType: null,
    key: 'otc',
    formatter: ruppeeFormatter,
    sortKey: 'OTC'
  },
  {
    headerName: 'Annual Recurring Charge*',
    isSort: true,
    sortType: null,
    key: 'arc',
    formatter: ruppeeFormatter,
    sortKey: 'ARC'
  },
  {
    headerName: 'Upload Date',
    isSort: true,
    sortType: null,
    key: 'uploadDate',
    sortKey: 'UPLOAD_DATE'
  },
  {
    headerName: 'Expiry Date/Status',
    isSort: false,
    sortType: null,
    key: 'expiryDate',
    sortKey: 'EXPIRY_DATE'
  }
];

export const PRODUCT_OPTIONS: Array<IDropDown> = [
  { displayName: 'VPN (MPLS)', key: 'MPLS' },
  { displayName: 'Dedicated Internet (ILL)', key: 'INTERNET' }
];

export const MEDIA_OPTIONS: Array<IDropDown> = [
  { displayName: 'Default', key: 'DEFAULT' },
  { displayName: 'Wireline', key: 'WIRELINE' },
  { displayName: 'Wireless', key: 'WIRELESS' },
  { displayName: '4G', key: 'FOUR_G' },
  { displayName: '5G', key: 'FIVE_G' },
  { displayName: 'Third Party', key: 'THIRD_PARTY' }
];

export const ALL_OPTIONS = {
  key: undefined,
  value: 'All',
  displayName: 'All'
};

export const SERVICE_OPTIONS = [
  ALL_OPTIONS,
  {
    id: 'MANAGED',
    displayName: 'Fully Managed',
    value: 'MANAGED',
    formKey: 'manageability',
    key: 'MANAGED'
  },
  {
    id: 'UNMANAGED',
    displayName: 'Unmanaged',
    value: 'UNMANAGED',
    formKey: 'manageability',
    key: 'UNMANAGED'
  },
  {
    id: 'PARTIALLY_MANAGED',
    displayName: 'Partially Managed',
    value: 'PARTIALLY_MANAGED',
    formKey: 'manageability',
    key: 'PARTIALLY_MANAGED'
  }
];

export const BANDWIDTHS = [ALL_OPTIONS].concat(prepareOptionsForDropDown(BANDWIDTH_LIST, 'value') as any[]);

export const IS_MULTIPLE_SORT = false;
export const DEFAULT_FILE_NAME = 'Rate_Card.xlsx';
export const isHeaderSet = 'isHeaderSet';

export const ERROR_MESSAGE = {
  UN_AUTHORIZED_TITLE: 'Sorry! You are not authorised to view the page.',
  UN_AUTHORIZED_BODY: 'You should have a role as KAM to view the page'
};
export const UN_AUTHORIZED_TITLE = 'Sorry! You are not authorised to view the page.';
export const UN_AUTHORIZED_BODY = 'You should have a role as KAM to view the page';
